import { Modal } from "antd-mobile";
import { Modal as AntModal } from "antd";
import { PollPopup } from "../Popup";
import { RouteProvider } from "views/components/Provider";
import Alert from "./Alert";
import AlmostThere from "./AlmostThere";
import Call from "./Call";
import React, { useDispatch, useGlobal } from "reactn";
import { useCurrentBreakpointName } from "react-socks";
import { TemporaryUserPopUp } from "views/components/common/TemporaryUserPopUp";
import Skipped from "./Skipped";
import Success from "./Success";
import { GenericModal } from "views/mobile/components/GenericModal";

const Provider = ({ children }) => {
	const [notifications] = useGlobal("notifications");
	const closeNotification = useDispatch("closeNotification");
	const enqueueNotification = useDispatch("enqueueNotification");
	const submitPoll = useDispatch("submitPollX");
	const breakpoint = useCurrentBreakpointName();

	const handleClose = (notif) => (_) => {
		enqueueNotification(notif);
	};

	const component = notifications.reduceRight((defaultN, notif) => {
		switch (notif.type) {
			case "success":
				return <Success onClose={closeNotification} {...notif} />;
			case "call":
				return breakpoint === "mobile" ? null : (
					<Call onClose={closeNotification} {...notif} />
				);
			case "almost_there":
				return <AlmostThere onClose={closeNotification} {...notif} />;
			case "skipped":
				return <Skipped onClose={closeNotification} />;
			case "alert":
				return (
					<Alert
						message={notif.message}
						onClose={closeNotification}
					/>
				);
			case "poll":
				return (
					<PollPopup
						office={notif.poll.office}
						line={notif.poll.line}
						ticket={notif.poll.ticket}
						onSubmit={submitPoll}
						// object clone to prevent memory leak
						onClose={handleClose({ ...notif })}
					/>
				);
			default:
				return defaultN;
		}
	}, null);

	return children({ breakpoint, component, visible: !!component });
};

const ProviderTemporary = ({ children }) => {
	const [notifications] = useGlobal("notifications");
	const closeNotification = useDispatch("closeNotification");
	const breakpoint = useCurrentBreakpointName();

	const component = notifications.reduceRight((defaultN, notif) => {
		switch (notif.type) {
			/* 			case "isTemporary":
				return (
					<TemporaryUserPopUp
						setShowModalTemporary={closeNotification}
						temporaryUserPopUp
					/>
				); */

			default:
				return defaultN;
		}
	}, null);

	return children({ breakpoint, component, visible: !!component });
};
const ProviderV2 = ({ children }) => {
	const [notifications] = useGlobal("notifications");
	const closeNotification = useDispatch("closeNotification");
	const breakpoint = useCurrentBreakpointName();

	const component = notifications.reduceRight((defaultN, notif) => {
		switch (notif.type) {
			case "new-alert":
				return (
					<GenericModal
						onCancel={closeNotification}
						temporaryUserPopUp
						visible={true}
						type={notif.type}
						description={notif.message}
					/>
				);
			case "block-already-taken-error":
				return (
					<GenericModal
						onCancel={closeNotification}
						temporaryUserPopUp
						visible={true}
						type={notif.type}
						description={notif.message}
					/>
				)
			case "generic-error":
				return (
					<GenericModal
						onCancel={closeNotification}
						temporaryUserPopUp
						visible={true}
						type={notif.type}
						description={notif.message}
					/>
				);
			case "new-alert-error":
				return (
					<GenericModal
						onCancel={closeNotification}
						temporaryUserPopUp
						visible={true}
						type={notif.type}
						description={notif.message}
					/>
				);
			default:
				return defaultN;
		}
	}, null);

	return children({ breakpoint, component, visible: !!component });
};

const Notification = ({ component, visible }) => {
	return (
		<Modal visible={visible} animationType="slide-up" popup>
			{component}
		</Modal>
	);
};
const NotificationTemp = ({ component, visible }) => {
	return (
		<Modal visible={visible} animationType="slide-up" popup>
			{component}
		</Modal>
	);
};
const NewNotification = ({ component }) => {
	return component;
};

export const NotificationProvider = RouteProvider(Provider);
export const NotificationTempProvider = RouteProvider(ProviderTemporary);
export const NotificationV2Provider = RouteProvider(ProviderV2);

export const TempNotification = NotificationTempProvider(NotificationTemp);
export const NotificationV2 = NotificationV2Provider(NewNotification);
export default NotificationProvider(Notification);
